/**
 * Agrupa entradas em `{ key, messages[] }`.
 *
 * @param {Array} items - strings ou objetos com mensagem (e opcionalmente chave).
 * @param {Object} [options]
 * @param {(item: *) => string|null|undefined} [options.getKey]
 * @param {(item: *) => string|null|undefined} [options.getMessage]
 * @param {string[]} [options.order] - ordem preferencial das chaves.
 * @returns {{ key: string, messages: string[] }[]}
 */
export function groupMessagesByKey(items, options = {}) {
    const {
        getKey = (item) => {
            if (item && typeof item === 'object') {
                return item.key ?? item.type ?? 'other';
            }
            return 'other';
        },
        getMessage = (item) => {
            if (typeof item === 'string') return item;
            return item?.message ?? null;
        },
        order = [],
    } = options;

    const normalized = (items || [])
        .map((item) => {
            const message = getMessage(item);
            if (!message) return null;
            return { key: String(getKey(item) ?? 'other'), message };
        })
        .filter(Boolean);

    const byKey = new Map();
    for (const { key, message } of normalized) {
        if (!byKey.has(key)) byKey.set(key, []);
        byKey.get(key).push(message);
    }

    const groups = [];
    for (const key of order) {
        const messages = byKey.get(key);
        if (messages?.length) {
            groups.push({ key, messages: [...messages] });
            byKey.delete(key);
        }
    }
    for (const [key, messages] of byKey) {
        if (messages.length) groups.push({ key, messages: [...messages] });
    }
    return groups;
}
